module.exports = __webpack_public_path__ + "6c4a0dbc/img/menu-icon.5f8facae.svg";